import i18next from "i18next"
import enUS from "./en-US.json"
import esES from "./es-ES.json"

const TRANSLATION_KEY = "campaigns"

i18next.on("initialized", () => {
  i18next.addResourceBundle("es-ES", `translation`, { [TRANSLATION_KEY]: esES })
  i18next.addResourceBundle("en-US", `translation`, { [TRANSLATION_KEY]: enUS })
})
